import React from "react";
import Layout from "../components/Layout";
import HeroSection from "../components/Hero";
import PlaylistAndSessions from "../components/PlaylistAndSessions";
import AboutUsSection from "../components/AboutUs";
import Customers from "../components/WhereToFindUs";
import BlogSection from "../components/BlogSection";
import useBlogs from "../utils/useBlogs";
import { useBreakpoint } from "gatsby-plugin-breakpoints/BreakpointProvider";
import { Helmet } from "../components/Layout/helmet";

const Home = () => {
  const breakpoints = useBreakpoint();
  const { blogs } = useBlogs();

  return (
    <Layout>
      <HeroSection isDesktop={!breakpoints.md} />
      <AboutUsSection />
      <PlaylistAndSessions isDesktop={!breakpoints.md} />
      <Customers isDesktop={!breakpoints.md} />
      {blogs.length > 0 && (
        <BlogSection blogs={blogs} isDesktop={!breakpoints.md} />
      )}
    </Layout>
  );
};

export const Head = () => (
  <Helmet>
    <title id="page-title">
      Blue Dot Sessions | Podcast Intro and Background Music | Music For
      Podcasts
    </title>
  </Helmet>
);

export default Home;
